import * as React from "react";
const SvgChevronDown = (props) => /* @__PURE__ */ React.createElement("svg", { width: 12, height: 8, viewBox: "0 0 12 8", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M1 1.5L5.96827 6.5L11 1.5", stroke: "currentColor", strokeWidth: 2 }));
export default SvgChevronDown;
